import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import AssetsEditForm from './AssetsEditForm';
import AssetsList from './AssetsList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import AssetsListView from './AssetsListView'


export default function AssetsDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.assetsDashboard);
  const [ assetsId, setAssetsId] = React.useState('');
  const [reloadAssetsList, setReloadAssetsList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <AssetsEditForm 
            setReloadAssetsList={setReloadAssetsList}
            assetsId={assetsId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <AssetsListView 
                      setAssetsId = {setAssetsId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
